// TODO : Redesign this page using MUI Table
import React, { useEffect, useState } from 'react';
import { Typography, Grid, Stack } from '@mui/material';
import { di } from '../../../../../../state/inversify.config';
import { AssessmentCreationViewService } from '../../../assessmentCreationView/assessmentCreation.view.service';
import { VomsDomainService } from './voms.domain';
import { RowData } from './rowData.dumb';
import { SkipModule } from '../../components/skipModule/skipModule.smart';
import { AssessmentModules } from '../../modules';
import { Notes } from '../../components/notes/notes.dumb';
import { useCustomTranslation } from '../../../../../../translation/customTranslation';

export function VOMS({ domainService }: any) {
  const vomsDomain: VomsDomainService =
    di.get<VomsDomainService>(VomsDomainService);
  const assessmentCreationViewService: AssessmentCreationViewService =
    di.get<AssessmentCreationViewService>(AssessmentCreationViewService);
  const { t } = useCustomTranslation('assessment');
  const { vestibularOcularMotorScreen } =
    assessmentCreationViewService.useModuleSelector();
  const moduleName: string = 'vestibularOcularMotorScreen';

  const [preRenderInitCompleted, setPreRenderInitCompleted] = useState(false);

  const {
    title,
    headerLabels,
    vomsBaselineSymptomsQuestion,
    vomsSmoothPursuitsQuestion,
    vomsSaccadesHorizontalQuestion,
    vomsSaccadesVerticalQuestion,
    vomsConvergenceQuestion,
    vomsVORHorizontalQuestion,
    vomsVORVerticalQuestion,
    vomsVisualMotionSensitivityTestQuestion,
    note,
  } = vomsDomain.dumbConfig();

  const defaults: any = {
    notTested: false,
    headache: '',
    dizziness: '',
    nausea: '',
    fogginess: '',
    clinicalNotes: '',
  };

  const defaultsConvergence: any = {
    ...defaults,
    convergenceNearPointMeasurement1: '',
    convergenceNearPointMeasurement2: '',
    convergenceNearPointMeasurement3: '',
  };

  const initRows = (skipModuleFlag: boolean): void => {
    if (vestibularOcularMotorScreen && !skipModuleFlag) {
      assessmentCreationViewService.dispatchSetAssessmentModule({
        vestibularOcularMotorScreen: {
          vomsBaselineSymptoms:
            vestibularOcularMotorScreen.vomsBaselineSymptoms,
          vomsSmoothPursuits: vestibularOcularMotorScreen.vomsSmoothPursuits,
          vomsSaccadesHorizontal:
            vestibularOcularMotorScreen.vomsSaccadesHorizontal,
          vomsSaccadesVertical:
            vestibularOcularMotorScreen.vomsSaccadesVertical,
          vomsConvergence: vestibularOcularMotorScreen.vomsConvergence,
          vomsVORHorizontal: vestibularOcularMotorScreen.vomsVORHorizontal,
          vomsVORVertical: vestibularOcularMotorScreen.vomsVORVertical,
          vomsVisualMotionSensitivityTest:
            vestibularOcularMotorScreen.vomsVisualMotionSensitivityTest,
          vomsNotes: vestibularOcularMotorScreen.vomsNotes,
          skipModuleFlag,
        },
      });
    } else {
      assessmentCreationViewService.dispatchSetAssessmentModule({
        vestibularOcularMotorScreen: {
          vomsBaselineSymptoms: defaults,
          vomsSmoothPursuits: defaults,
          vomsSaccadesHorizontal: defaults,
          vomsSaccadesVertical: defaults,
          vomsConvergence: defaultsConvergence,
          vomsVORHorizontal: defaults,
          vomsVORVertical: defaults,
          vomsVisualMotionSensitivityTest: defaults,
          vomsNotes: '',
          skipModuleFlag,
        },
      });
    }
    setPreRenderInitCompleted(true);
  };

  const saveAnswersResponse = (
    rowName: string,
    key: string,
    value: string,
  ): void => {
    let vomsResponse = {};

    if (key === 'notTested' && value) {
      if (rowName === 'vomsConvergence') {
        vomsResponse = {
          ...vestibularOcularMotorScreen?.[rowName],
          notTested: true,
          headache: '',
          dizziness: '',
          nausea: '',
          fogginess: '',
          convergenceNearPointMeasurement1: '',
          convergenceNearPointMeasurement2: '',
          convergenceNearPointMeasurement3: '',
          vomsNotes: '',
          skipModuleFlag: false,
        };
      } else {
        vomsResponse = {
          ...vestibularOcularMotorScreen?.[rowName],
          notTested: true,
          headache: '',
          dizziness: '',
          nausea: '',
          fogginess: '',
          vomsNotes: '',
          skipModuleFlag: false,
        };
      }
    } else {
      vomsResponse = {
        ...vestibularOcularMotorScreen?.[rowName],
        [key]: value,
        notTested: false,
      };
    }
    vomsDomain.resetSkipModule(moduleName);

    assessmentCreationViewService.dispatchSetAssessmentModuleDetails(
      moduleName,
      rowName,
      vomsResponse,
    );
  };

  const setNotesComments = (key: string, value: string): void => {
    assessmentCreationViewService.dispatchSetAssessmentModuleDetails(
      moduleName,
      key,
      value,
    );

    vomsDomain.resetSkipModule(moduleName);
  };

  useEffect(() => {
    domainService.dispatchNextEnabledAndValidate(
      vestibularOcularMotorScreen,
      AssessmentModules.VOMS,
    );
    domainService.dispatchBackEnabled(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vestibularOcularMotorScreen]);

  useEffect((): void => {
    // Run once to prevent:
    // Warning: A component is changing a controlled input to be uncontrolled.
    // This is likely caused by the value changing from a defined to undefined...
    initRows(
      vestibularOcularMotorScreen
        ? vestibularOcularMotorScreen.skipModuleFlag
        : false,
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setVOMSAssessmentTableHeader = () => {
    return (
      <>
        {headerLabels.map((item: any) => {
          return (
            <Grid
              key={item.value}
              display="flex"
              textAlign="center"
              sx={{ p: 1, width: '30%' }}
            >
              {t(item.key)}
            </Grid>
          );
        })}
      </>
    );
  };

  const skipModuleOnChange = (value: boolean): void => {
    initRows(value);
  };

  if (!preRenderInitCompleted) {
    return <></>;
  }

  return (
    <>
      <Typography variant="h6" fontWeight="bold">
        {t(title)}
      </Typography>
      <Stack direction="column" spacing={1} sx={{ mt: 2 }}>
        <Stack direction="row">{setVOMSAssessmentTableHeader()}</Stack>
        <Stack direction="row" alignContent="right">
          <RowData
            question={vomsBaselineSymptomsQuestion}
            setResponse={saveAnswersResponse}
            data={vestibularOcularMotorScreen?.vomsBaselineSymptoms}
          />
        </Stack>
        <Stack direction="row">
          <RowData
            question={vomsSmoothPursuitsQuestion}
            setResponse={saveAnswersResponse}
            data={vestibularOcularMotorScreen?.vomsSmoothPursuits}
          />
        </Stack>
        <Stack direction="row">
          <RowData
            question={vomsSaccadesHorizontalQuestion}
            setResponse={saveAnswersResponse}
            data={vestibularOcularMotorScreen?.vomsSaccadesHorizontal}
          />
        </Stack>
        <Stack direction="row">
          <RowData
            question={vomsSaccadesVerticalQuestion}
            setResponse={saveAnswersResponse}
            data={vestibularOcularMotorScreen?.vomsSaccadesVertical}
          />
        </Stack>
        <Stack direction="row">
          <RowData
            question={vomsConvergenceQuestion}
            setResponse={saveAnswersResponse}
            data={vestibularOcularMotorScreen?.vomsConvergence}
          />
        </Stack>
        <Stack direction="row">
          <RowData
            question={vomsVORHorizontalQuestion}
            setResponse={saveAnswersResponse}
            data={vestibularOcularMotorScreen?.vomsVORHorizontal}
          />
        </Stack>
        <Stack direction="row">
          <RowData
            question={vomsVORVerticalQuestion}
            setResponse={saveAnswersResponse}
            data={vestibularOcularMotorScreen?.vomsVORVertical}
          />
        </Stack>
        <Stack direction="row">
          <RowData
            question={vomsVisualMotionSensitivityTestQuestion}
            setResponse={saveAnswersResponse}
            data={vestibularOcularMotorScreen?.vomsVisualMotionSensitivityTest}
          />
        </Stack>
        {note && (
          <Notes
            label={t(note.label)}
            keyValue={note.key}
            onSave={setNotesComments}
            data={vestibularOcularMotorScreen?.vomsNotes || ''}
            fullWidth
          />
        )}
        <SkipModule
          moduleKeyValue={moduleName}
          skipModuleFlag={vestibularOcularMotorScreen?.skipModuleFlag}
          skipModuleComments={vestibularOcularMotorScreen?.skipModuleComments}
          onChange={skipModuleOnChange}
        />
      </Stack>
    </>
  );
}
